<template>
  <div v-if="mate" class="flex items-center gap-2">
    <div :class="avatarClass">
      <UserAvatar :mate="mate" />
    </div>

    <div class="flex-1">
      <h3 :class="['line-clamp-1 mb-0.5', nameClass]">
        {{ useName(mate.name) }}

        <span
          class="text-shadow text-base-content/50 text-xs"
          v-if="!mateStore.isMyMateById(mate.id)"
        >
          by {{ getMockName(mate.id!) }}
        </span>
      </h3>
      <p
        :class="['text-base-content/70 line-clamp-1 text-xs', bioClass]"
        v-html="mate.bio || mate.personalityPrompt || ''"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMate } from "@/stores/mate";
import { Mate } from "@/types/entity";
import { useName } from "@/use/common";
import { getMockName } from "@/views/Mate/Create/MateCreatePresetMock";

const mateStore = useMate();
withDefaults(
  defineProps<{
    mate: Mate;
    avatarClass?: string;
    nameClass?: string;
    bioClass?: string;
    showMockName?: boolean;
  }>(),
  {
    avatarClass: "w-8",
    nameClass: "",
    bioClass: "",
    showMockName: false,
  }
);
</script>
